// extracted by mini-css-extract-plugin
export default {"CourseTransactions":"CourseTransactions_CourseTransactions__OWcCd","ActionRenderer":"CourseTransactions_ActionRenderer__A8zPq"};